import React from "react";

import { ScrollNavMenuBlock as ScrollNavMenuBlockValue } from "@reactivated";

import { injectComponents } from "../../utils/injection";
import { MenuItem, MenuItemClassNames } from "./MenuItem";
import {
    ScrollNavMenuContainer,
    ScrollNavMenuContainerClassNames,
} from "./ScrollNavMenuContainer";
import { useMenuItems } from "./hooks";

type ScrollNavMenuBlockClassNames = ScrollNavMenuContainerClassNames &
    MenuItemClassNames;

const dependencies = {
    ScrollNavMenuContainer,
    MenuItem,
} as const;

/**
 * Renders a sticky "table of contents" nav bar for navigating between sections
 * in the page. Items in the ToC are derived from whatever ScrollNavMenuItemBlock
 * components are also rendered on the page.
 */
export const ScrollNavMenuBlock = injectComponents(dependencies)<{
    value: ScrollNavMenuBlockValue;
    classNames?: ScrollNavMenuBlockClassNames;
}>((props) => {
    const { ScrollNavMenuContainer, MenuItem } = props.dependencies;
    const navItems = useMenuItems();
    return (
        <ScrollNavMenuContainer classNames={props.classNames}>
            {navItems.map((navItem) => (
                <MenuItem
                    key={navItem.elemID}
                    navItem={navItem}
                    classNames={props.classNames}
                />
            ))}
        </ScrollNavMenuContainer>
    );
});
